import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noVersion: {
		id: 'issue-table-grouping.group-row.group-header.version-group-header.no-version',
		defaultMessage: 'No version',
		description: 'Label for grouped items without version value',
	},
});
export default messages;
